import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToolsService } from 'src/app/services/tools/tools.service';
import { MediaObserver } from '@angular/flex-layout';
import { AuthPageManageService } from 'src/app/services/manage/page-manage/auth-page-manage.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { PointOfSaleDetails } from 'src/app/services/api/fulle/fulle-pointOfSale/fulle-pointOfSale.service.interface';

@Component({
  selector: 'app-header-booking',
  templateUrl: './header-booking.component.html',
  styleUrls: ['./header-booking.component.css']
})
export class HeaderBookingComponent implements OnInit {

  @Input() currUser$: any;
  @Input() pointOfSale: PointOfSaleDetails | null = null;
  @Input() bookingSettings: any;
  @Input() redirectPage: string|any;
  @Input() merchant: any;
  @Output() goWebShopEvent = new EventEmitter<any>();

  constructor(
    public media: MediaObserver,
    public tools: ToolsService,
    public authPageServ: AuthPageManageService,
    private authService: AuthService,
  ) { }

  ngOnInit() { }

  /**
   * @description Déconnecte l'utilisateur
   * @returns {void}
   */
  logOut(): void {
    this.authService.logOut();
  }

  /**
   * @description Redirige vers el webshop
   * @returns {void}
   */
  goWebShop(): void {
    this.goWebShopEvent.emit();
  }

  /**
 * @description Check si le commerçant à l'option webshop
 * @return {boolean}
 */
  conditionWebShop(): boolean {
    return this.merchant.options.includes("ONLINE_ORDER_GESTION");
  }

}
